import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';
import { createStrokeValidator } from './validator';

const strokeAction = {
  ...createDefaultActionDefinition(StylesDerivedNativeActions.strokeStyles),
  validator: createStrokeValidator(),
};

export default strokeAction;
